import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import AuthGuard from './router-guards/auth-guard';

// Uncomment to generate CSV of routes
// import downloadRoutesCSV from './download-routes-csv';
// downloadRoutesCSV(routes, { filename: 'routes.csv' });

Vue.use(VueRouter);

const ROUTER = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.VUE_APP_BASE_URI ? process.env.VUE_APP_BASE_URI : '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (to.meta.transitionIn && to.meta.transitionIn === 'slide-up') {
        return;
      } else {
        return { x: 0, y: 0 };
      }
    }
  },
});

ROUTER.beforeEach(AuthGuard);

export default ROUTER;
